<template>
  <b-modal
    id="modal-view-compoff-requests"
    ref="modal-view-compoff-requests"
    title="My CO Balance Requests"
    ok-only
    ok-title="Close"
    size="lg"
  >
    <div v-if="loadingCompOffRequests" class="text-center py-3">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      <p class="mt-2 text-muted">Loading your CO balance requests...</p>
    </div>

    <div v-else-if="compOffBalanceRequests.length === 0" class="text-center py-4">
      <feather-icon icon="InboxIcon" size="48" class="text-muted mb-3" />
      <p class="text-muted">No CO balance requests found.</p>
      <b-button
        variant="primary"
        size="sm"
        @click="$emit('create-request')"
      >
        <feather-icon icon="PlusCircleIcon" size="14" class="mr-50" />
        Create Request
      </b-button>
    </div>

    <b-table
      v-else
      :items="compOffBalanceRequests"
      :fields="compOffRequestsFields"
      responsive
      striped
      hover
      class="mb-0"
    >
      <template #cell(work_date)="data">
        {{ formatDate(data.item.from_date || data.item.work_date) }}
      </template>

      <template #cell(total_days)="data">
        {{ data.item.total_days != null ? data.item.total_days + (data.item.total_days === 1 ? ' day' : ' days') : '-' }}
      </template>

      <template #cell(createdAt)="data">
        {{ formatDate(data.item.created_at || data.item.createdAt) }}
      </template>

      <template #cell(status)="data">
        <b-badge
          :variant="getStatusVariant(data.item.status)"
          pill
        >
          {{ data.item.status }}
        </b-badge>
      </template>

      <template #cell(actions)="data">
        <b-button
          size="sm"
          variant="outline-primary"
          aria-label="View details"
          @click="$emit('view-detail', data.item)"
        >
          <feather-icon icon="EyeIcon" size="12" />
        </b-button>
      </template>
    </b-table>
  </b-modal>
</template>

<script>
import {
  BModal, BSpinner, BButton, BTable, BBadge,
} from 'bootstrap-vue'

export default {
  name: 'ViewCompOffRequestsModal',
  components: {
    BModal, BSpinner, BButton, BTable, BBadge,
  },
  props: {
    loadingCompOffRequests: { type: Boolean, default: false },
    compOffBalanceRequests: { type: Array, default: () => [] },
    compOffRequestsFields: { type: Array, default: () => [] },
    formatDate: { type: Function, default: (d) => d },
    getStatusVariant: { type: Function, default: () => 'secondary' },
  },
}
</script>
